import { Layout } from "@components/index";
import React, { useEffect, useState } from "react";
import LessonFilter from "../Lesson/LessonFilter";
import { ILevel, LevelIApiResponse, UpdateLevelPayload } from "src/types";
import { listLevels } from "src/service/activities.services";
import showToast from "@utils/toast";
import { NavLink } from "react-router-dom";
import { getFromMemory, levelId, saveToMemory } from "@utils/storage.utils";
import EditLevelModal from "./components/EditLevelModal";

// const logo = import()
import logo from "../../image/logo.png";

interface ILevelPage {
  isLoading: boolean;
  levels: LevelIApiResponse["result"];
}

const LevelsList = () => {
  const [editingLevel, setEditingLevel] = useState<ILevel | null>(null);

  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    getFromMemory("language") || ""
  );
  const [levelList, setLevelList] = useState<ILevelPage>({
    isLoading: true,
    levels: [],
  });

  useEffect(() => {
    const fetchLevels = async () => {
      if (!selectedLanguage) return;

      setLevelList((prev) => ({ ...prev, isLoading: true }));

      try {
        const levels = await listLevels(selectedLanguage);
        if (levels.status === "success") {
          setLevelList({ isLoading: false, levels: levels.result });
        } else {
          setLevelList({ isLoading: false, levels: [] });
        }
      } catch (error: any) {
        setLevelList({ isLoading: false, levels: [] });
        showToast(error?.message || "Failed to fetch levels", false);
      }
    };

    fetchLevels();
  }, [selectedLanguage]);

  const directTOLessonPageUrl = (level: ILevel) => {
    saveToMemory("levelId", level.id);
    saveToMemory(
      "CurentLevelInfo",
      JSON.stringify({
        title: level.title,
        level: level.level,
        levelId: level.id,
      })
    );
    return;
  };

  return (
    <Layout>
      <div className="container mx-auto p-5 flex justify-between py-7">
        <div>
          <button
            onClick={() => (window.location.href = `/dashboard/levels/add`)}
            className="bg-brand text-white  px-4 py-2 rounded-md hover:bg-brand-dark transition"
          >
            Add Level
          </button>
        </div>

        <LessonFilter
          selectedLanguage={selectedLanguage}
          onLanguageChange={setSelectedLanguage}
        />
      </div>

      {/* </div> */}
      <div className="container mx-auto p-5">
        {levelList.isLoading ? (
          <p className="text-base">Loading levels...</p>
        ) : levelList.levels.length === 0 ? (
          <p>No levels available yet.</p>
        ) : (
          <div className="space-y-6">
            {levelList.levels.map((level) => (
              <div
                key={level.id}
                className="bg-white rounded-lg shadow-md p-5 flex flex-col sm:flex-row items-center gap-6"
              >
                <img
                  src={logo}
                  alt={level.image}
                  className="w-32 h-32 object-cover rounded-md"
                />

                <div className="flex-1">
                  <h2 className="text-xl font-bold text-gray-900">
                    {level.title}
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Desc: {level.description}
                  </p>
                  <div className="mt-3 flex flex-wrap gap-2 text-sm text-gray-700">
                    <span className="font-semibold">Level:</span> {level.level}
                    <span className="font-semibold">Language:</span>{" "}
                    {level.language}
                  </div>

                  <div className="mt-4 flex flex-row sm:flex-row gap-2 justify-between">
                    <NavLink
                      to={`/dashboard/levels/lessons`}
                      className="block px-5 py-2 rounded-md bg-brand text-white hover:bg-brand-dark transition"
                      onClick={() => directTOLessonPageUrl(level)}
                    >
                      See Lessons
                    </NavLink>
                    <button
                      onClick={() => setEditingLevel(level)}
                      className="px-5 py-2 rounded-md border border-brand text-brand hover:bg-brand hover:text-white transition text-sm"
                    >
                      Edit Level
                    </button>

                    {editingLevel && (
                      <>
                        <EditLevelModal
                          level={editingLevel}
                          onClose={() => setEditingLevel(null)}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default LevelsList;
